import React from "react";
import "./Enterprise.scss";
import { Button } from "antd";
import { CALENDLY_LINK, PORTAL_BASE_URL } from "../../../../env";

const Enterprise = () => {
  const utm_source = localStorage.getItem('utm_source') || null;
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=enterprise_collab&is_enterprise=true&utm_source=${utm_source}`;

  return (
    <section className="enterprise">
      <div className="enterprise__container">
        <div className="enterprise__image-grid">
          <div className="enterprise__image-item enterprise__image-item--large">
            <img
              src="/enterprise/enterprise_chair.png"
              alt="Comfortable chair"
            />
          </div>
          <div className="enterprise__image-item">
            <img
              src="/enterprise/enterprise_interior.png"
              alt="Interior design"
            />
          </div>
          <div className="enterprise__image-item">
            <img src="/enterprise/enterprise_jar.png" alt="Product jar" />
          </div>
          <div className="enterprise__image-item">
            <img
              src="/enterprise/enterprise_greenhouse.png"
              alt="Wooden greenhouse"
            />
          </div>
        </div>
        <div className="enterprise__content">
          <h2 className="enterprise__label manrope f-16 w-700 lh-24 mb-16">ALL3D Enterprise</h2>
          <h1 className="enterprise__heading manrope width-80">
            Optimize team collaboration and workflows with a custom enterprise plan
          </h1>
          <p className="enterprise__description manrope f-16 w-500 lh-24 width-80 mb-32">
            Get full access to the ALL3D platform customized for your business. Whether you're an SMB seller, retailer, or manufacturer, we'll tailor a plan that scales with your team and streamlining workflows.
          </p>
          <div className="enterprise__cta">
            <Button
             className="manrope f-16 w-700 lh-24 blue-button"
              onClick={() =>
                window.open(CALENDLY_LINK, "_blank")
              }
            >
              Schedule a Demo
            </Button>
            <Button
              className="manrope f-16 w-700 lh-24 white-button-black-border white-text"
              onClick={() =>
                window.open(`${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(redirectPath)}`, "_blank")
              }
            >
              Start your free trial
            </Button>
          </div>
         
        </div>
      </div>
    </section>
  );
};

export default Enterprise;
